export const CommitteeMemberEndpoints = {
    createCommitteeMember: {
        method: "post",
        url: "/national-committees",
    },
    getAllCommitteeMembers: {
        method: "get",
        url: "/national-committees",
    },
    getCommitteeMember: (id) => ({
        method: "get",
        url: `/national-committees/${id}`,
    }),
    updateCommitteeMember: (id) => ({
        method: "put",
        url: `/national-committees/${id}`,
    }),
    deleteCommitteeMember: (id) => ({
        method: "delete",
        url: `/national-committees/${id}`,
    }),
}